export default defineNuxtRouteMiddleware(async (to) => {
  const { userRole } = useAuth()

  if (to.meta.managerOnly && userRole.value != "admin") {
    return navigateTo({ name: "dashboard" })
  }
})
